import { Alert, Button, Form, Input } from 'antd'
import { FC } from 'react'
import { SVGs } from '../../../../../assets'
import { BitazzaModal, BitazzaText } from '../../../../../components'

import Styles from './ProfileNameModal.module.scss'
import BadWordsFilter from 'bad-words'
import { useTranslation } from 'react-i18next'

interface Props {
    profileName?: string
    isOpen: boolean
    onChangeProfileName?: (name: string) => void
    onCLoseModal: () => void
}
export const ProfileNameModal: FC<Props> = ({
    profileName,
    onChangeProfileName,
    isOpen,
    onCLoseModal,
}) => {
    const { t } = useTranslation()
    const filter = new BadWordsFilter()
    const onFinishFailed = (errorInfo: any) => {
        console.log('Failed:', errorInfo)
    }
    const specials = /^[ A-Za-z0-9-#]*$/
    return (
        <>
            <BitazzaModal
                closable={false}
                footer={null}
                size="270px"
                onCancel={onCLoseModal}
                isModalOpen={isOpen}
                title={
                    <div className={Styles.editProfileHeader}>
                        <div>
                            <BitazzaText
                                content={t('txt_edit_name')}
                                format="t20"
                                color="#FFFFFF"
                                bold
                            />
                        </div>
                        <div>
                            <BitazzaText
                                content={t('txt_cancel')}
                                format="t20"
                                color="#F1D87E"
                                onClick={onCLoseModal}
                                noUnderline={true}
                                bold
                            />
                        </div>
                    </div>
                }
            >
                <div className={Styles.modalContainer}>
                    <Form
                        labelCol={{ span: 8 }}
                        wrapperCol={{ span: 16 }}
                        style={{ maxWidth: 600 }}
                        initialValues={{
                            profileName,
                        }}
                        onFinish={onChangeProfileName}
                        onFinishFailed={onFinishFailed}
                        autoComplete="off"
                    >
                        <Form.Item
                            className={Styles.LabelProfileName}
                            label={
                                <BitazzaText
                                    content={t('txt_profile_name')}
                                    format="t18"
                                    color="#86A1A1"
                                />
                            }
                            name="profileName"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your username!',
                                },
                                {
                                    validator: (_, value) => {
                                        if (specials.test(value)) {
                                            return Promise.resolve()
                                        } else {
                                            return Promise.reject(
                                                'special characters'
                                            )
                                        }
                                    },
                                    message: t('txt_profile_Special'),
                                },
                                {
                                    min: 2,
                                    message: t('txt_profile_char'),
                                },
                                {
                                    max: 8,
                                    message: t('txt_profile_char'),
                                },
                                {
                                    message: t('txt_profile_impolite'),
                                    validator: (_, value) => {
                                        if (!filter.isProfane(value)) {
                                            return Promise.resolve()
                                        } else {
                                            return Promise.reject('bad-word')
                                        }
                                    },
                                },
                            ]}
                        >
                            <Input className={Styles.input} />
                        </Form.Item>
                        <div className={Styles.alertContainer}>
                            <Alert
                                message={t('txt_profile_name_des')}
                                type="warning"
                                showIcon
                                className={Styles.alert}
                                icon={<img src={SVGs.info} alt="info" />}
                            />
                        </div>

                        <Form.Item>
                            <Button htmlType="submit" className={Styles.button}>
                                {t('txt_save')}
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </BitazzaModal>
        </>
    )
}
